import breakpoints from '../../../../styles/breakpoints';

// The gallery's layout only changes at these widths (see getNumberOfColumns and Gallery), so mapping
// the app breakpoint onto them lets galleries skip re-rendering when any other breakpoint changes.
const galleryBreakpoints = [breakpoints.MEDIUM, breakpoints.SMALL, breakpoints.XSMALL];

export default function selectGalleryBreakpoint(breakpoint) {
  return (
    galleryBreakpoints.find((galleryBreakpoint) => breakpoint >= galleryBreakpoint) ??
    breakpoints.MIN
  );
}
